import { styled } from '@lessonup/ui-components';
import React from 'react';

/**
 * An absolutely positioned wrapper that aligns itself to the top center of the nearest non-static ancestor.
 * This component only handles positioning, no styling.
 */
export const TopAligned: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <StyledTagContainer>{children}</StyledTagContainer>;
};

const StyledTagContainer = styled.div`
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`;
